import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

function AboutUs({ className, titleKey, textKey }) {
  const containerRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top 75%",
          end: "bottom top",
          toggleActions: "play none none reverse",
        },
      });

      const h1 = containerRef.current.querySelector("h1");
      const ps = containerRef.current.querySelectorAll("p");

      tl.fromTo(
        h1,
        { opacity: 0, y: 22, filter: "blur(2px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 0.6,
          ease: "power2.out",
        }
      ).fromTo(
        ps,
        { opacity: 0, y: 22, filter: "blur(2px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 0.6,
          ease: "power2.out",
          stagger: 0.12,
        },
        "-=0.48"
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className={className} ref={containerRef}>
      <article>
        <h1>{t(titleKey)}</h1>
        {t(textKey)
          .split("\n")
          .map((para, i) => (
            <p key={i}>
              {para.split("\n").map((line, j) => (
                <React.Fragment key={j}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          ))}
      </article>
    </div>
  );
}

export default AboutUs;
